import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

import './style.scss';

interface IProps {
  type?: string;
}

export function RewardBookingType(props: IProps) {
  const { type } = props;
  if (isEmpty(type)) return null;

  const value = (type ?? '').toLowerCase();
  const className =
    value === 'hotel'
      ? 'hotel'
      : value === 'condo'
        ? 'condo'
        : value === 'car'
          ? 'car'
          : value === 'activity'
            ? 'activity'
            : 'default';

  return (
    <div className="reward-booking-type">
      <div className={`reward-booking-type__box ${className}`}>
        <FormattedMessage id={type ?? ''} defaultMessage={type} />
      </div>
    </div>
  );
}
